<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// axios
import axios from './axios/axios';
// noty
import notify from "./helpers/notify";

export default {
  name: 'app',
  /*mounted() {
    axios.interceptors.response.use( (response) => {
      return response;
    }, (err) => {
      if (err.response) {
        notify.call(this, this.$t('errors.unknown.title'), "error");
        return Promise.reject(err);
      }
      return Promise.reject(err);
    });
  },*/
};
</script>

<style>
  @import "./assets/css/material.css";
  body {
    font-family: "Helvetica Neue", "Arial", sans-serif;
    font-size: 14px;
    padding: 0;
    margin: 0;
  }
</style>
